import { useApiClient } from '@siclop/kstone-vue'

/** DELETE : le client rend un résultat en échec au lieu de lever une erreur (400, 403…). */
export async function deleteOrThrow(path: string): Promise<void> {
  const result = await useApiClient().delete(path)
  if (result && typeof result === 'object' && 'success' in result && result.success === false)
    throw new Error((result.errors ?? []).join(' ') || 'Suppression refusée')
}
